import { ITimeSlot } from 'interfaces/timeslotType';
import { MINUTE_OF_A_BLOCK } from './convertMinutesIntoHoursOfDay';
import getIntervalStep from './getIntervalStep';

export const getBlocksPerInterval = (
  blocks: number[],
  slotInterval?: number
) => {
  const step = getIntervalStep(slotInterval);

  const blocksPerInterval: number[] = [];

  for (let index = 0; index < blocks.length; index++) {
    if (index === 0) {
      blocksPerInterval.push(blocks[0]);
      continue;
    }

    const lastBlockPerInterval = blocksPerInterval[blocksPerInterval.length - 1];

    if (blocks[index] > lastBlockPerInterval + step) {
      blocksPerInterval.push(blocks[index]);
      continue;
    }
  }

  return blocksPerInterval;
};

export const getSlotsPer30MinutesForAvailability = (
  timeSlots?: ITimeSlot[],
  slotInterval?: number
) => {
  if (!timeSlots) return [];

  return timeSlots.map((timeSlot) => {
    if (timeSlot.isOptimizedApplied) {
      return timeSlot;
    }

    return {
      ...timeSlot,
      blocks: getBlocksPerInterval(timeSlot.blocks, slotInterval),
    };
  });
};

export const getSlotsPer30MinutesForCard = <T extends { value: number }>(
  timeSlots?: T[]
) => {
  if (!timeSlots) return [];

  const blocksPer30Minutes = [];
  for (let index = 0; index < timeSlots.length; index++) {
    if (index === 0) {
      blocksPer30Minutes.push(timeSlots[0]);
      continue;
    }
    const lastBlocksPer30Minutes =
      blocksPer30Minutes[blocksPer30Minutes.length - 1];

    const step = 25 / MINUTE_OF_A_BLOCK; // 25 minutes

    if (timeSlots[index].value > lastBlocksPer30Minutes.value + step) {
      blocksPer30Minutes.push(timeSlots[index]);
      continue;
    }
  }
  return blocksPer30Minutes;
};
